import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/Auth.css';

function VerifyEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState('');

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    setToken(tokenParam || '');

    if (tokenParam) {
      verifyEmail(tokenParam);
    } else {
      setLoading(false);
    }
  }, [searchParams]);

  const verifyEmail = async (verificationToken) => {
    try {
      const response = await authAPI.verifyEmail(verificationToken);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.userId);
      setSuccess('Email verified successfully! Redirecting...');
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Verification failed. Token may have expired.');
    } finally {
      setLoading(false);
    }
  };

  const handleManualVerify = async (e) => {
    e.preventDefault();
    if (!token) {
      setError('Please enter the verification token from your email');
      return;
    }
    setLoading(true);
    await verifyEmail(token);
  };

  return (
    <div className="app-container">
      <div className="auth-card">
        <div className="auth-logo">
          <h1>🖥️ MSN Messenger</h1>
          <p>Verify your email</p>
        </div>

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        {loading && !success && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div className="spinner"></div>
            <p style={{ marginTop: '16px', color: '#666' }}>Verifying your email...</p>
          </div>
        )}

        {!loading && !success && (
          <>
            <p style={{ color: '#666', marginBottom: '20px', textAlign: 'center' }}>
              Check your email for the verification link. If you don't see it, you can paste the token below.
            </p>

            <form onSubmit={handleManualVerify}>
              <div className="form-group">
                <label htmlFor="token">Verification Token</label>
                <input
                  id="token"
                  type="text"
                  placeholder="Paste the token from your email"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                />
              </div>

              <button type="submit" className="btn">
                Verify Email
              </button>
            </form>

            <div className="auth-footer">
              <Link to="/login">Back to login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
